import { render } from "./PostNode.vue?vue&type=template&id=31a453a2&ts=true"
import script from "./PostNode.vue?vue&type=script&lang=ts"
export * from "./PostNode.vue?vue&type=script&lang=ts"

import "./PostNode.vue?vue&type=style&index=0&id=31a453a2&lang=css"

import exportComponent from "/home/runner/work/islander-vue-web/islander-vue-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__